<template>

  <lu-vbox lu-flex class="app-container vpad-in-5">

    <lu-vbox><PageHeader title='I-Risk Monitor View' /></lu-vbox>

	</lu-vbox>
</template>

<script>
import { LuVbox } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'

export default {
	name: 'nettingMarkup',
  components: { PageHeader, LuVbox },
	methods: {
  }
}

</script>
